// This component has been added ad-hoc by coaching-fe team: https://private.hubteam.com/janus/groups/hs-coaching-fe
// For any questions/concerns, please use Slack channel: #coaching-fe

import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import has from 'transmute/has';
import { Metrics } from '../../../../../metrics/Metrics';
import { getQueryParams } from '../../../../../utils/urlUtils';
const NUM_VIEWS_TRANSCRIPT_SETTING_SHEPHERD = 'NUM_VIEWS_TRANSCRIPT_SETTING_SHEPHERD';
const useTranscriptionShepherdViewCounter = ({
  onLoadedNumberOfViews
}) => {
  const [numberOfViews, setNumberOfViews] = useState(0);
  const urlParams = getQueryParams(window.location);
  const increaseNumberOfViews = () => {
    const newNumberOfViews = (numberOfViews || 0) + 1;
    setNumberOfViews(newNumberOfViews);
    try {
      localStorage.setItem(NUM_VIEWS_TRANSCRIPT_SETTING_SHEPHERD, String(newNumberOfViews));
      Metrics.counter(NUM_VIEWS_TRANSCRIPT_SETTING_SHEPHERD).increment();
    } catch (err) {
      // do nothing
    }
  };
  useEffect(() => {
    let isMounted = true;
    try {
      const result = localStorage.getItem(NUM_VIEWS_TRANSCRIPT_SETTING_SHEPHERD) || 0;
      const tourAlreadySpecified = has('tourId', urlParams);
      if (isMounted && !tourAlreadySpecified) {
        const numViewsStorage = Number(result);
        setNumberOfViews(numViewsStorage);
        onLoadedNumberOfViews(numViewsStorage);
      }
    } catch (err) {
      Raven.captureException(err);
    }
    return () => {
      isMounted = false;
    };
  }, [onLoadedNumberOfViews, urlParams]);
  return {
    increaseNumberOfViews
  };
};
export default useTranscriptionShepherdViewCounter;